<template lang="jade" src="./target.jade"></template>

<script>
  export default {
    data () {
      return {
        animated_headline: "https://s3-us-west-1.amazonaws.com/db13/1440/hdr.svg",
        title: 'I am You.',
        copy: 'Every fibre of my being is fine tuned to perceptible nuance. I want it all. Unlimited, ubiquitous access. Don’t put up a wall between me and my potential to realize more, see the truth, feel deeply. At long last, I see not a trend nor phase, not a line item on my bill… I see limitless possibility. Who would dare to close off this brilliant vision from any screen or portal? HDR. Historic Delivery Radiance? High Dynamic Range! This vision is mine and all of ours; the many, not the few. This is what I…',
        lastword: 'BELIEVE',
        video: 'https://s3-us-west-1.amazonaws.com/db13/1440/consumers.mp4',
        back_link: '/ce-distributors',
        forward_link: '/content-creators',
        back_img: 'imgs/icons/back-arrow.svg',
        forward_img: 'imgs/icons/forward-arrow.svg',
        back: 'imgs/icons/back-arrow.svg',
        vTransparency: {
          opacity: '0.5'
        }
      }
    }
  }
</script>

<style lang="sass?indentedSyntax" scoped>

  @import "../../_sass/utilities/_utilities.sass"

  h1,
  span.beleive
    color: $lt-blue!important

</style>


/** WEBPACK FOOTER **
 ** consumers.vue?ad1811c2
 **/